module.exports = __webpack_public_path__ + "static/media/fitbit-background.f4eece8c.png";